import Vue from 'vue';
import axios from 'axios';

const checkDisclaimer = (userInfo, state, totalTraining, check) => {
	let status_id =
		userInfo &&
		userInfo.people &&
		userInfo.people.last_people_advisor_training_with_trashed &&
		userInfo.people.last_people_advisor_training_with_trashed.last_log ?
			userInfo.people.last_people_advisor_training_with_trashed.last_log.status_id : null;


	if (state.loaded === true && (status_id == 3 || status_id == 5) && totalTraining == 2) {
		check = true;
	} else {
		check = false;
	}

	return check;
};
// States
const state = {
	onlyRead: true,
	peopleAdvisorTraining: false,
	loaded: false
};

// Getters
const getters = {
	peopleAdvisorTraining(state) {
		return state.peopleAdvisorTraining;
	},
	loaded(state) {
		return state.loaded;
	},
	onlyRead(state, getters, rootState, rootGetters) {
		let check = true;
		let userInfo = rootGetters.userInfo;
		let totalTraining = rootGetters['youngSecondPart/totalTraining'];
		state.onlyRead = checkDisclaimer(userInfo, state, totalTraining, check);
		return state.onlyRead;
	},
	checkLetter(state, getters, rootState, rootGetters) {
		let check = true;
		let form = rootGetters['young/form'];
		if (form && form.a_fellow && form.a_fellow.person && form.a_fellow.person.documents) {
			form.a_fellow.person.documents.forEach((item) => {
				if (item.cat_document_type_id == 6 && item.id) {
					check = false;
				}
			});

		}
		return check;
	},
	showDisclaimer(state, getters, rootState, rootGetters) {
		let check = false;
		let userInfo = rootGetters.userInfo;
		let totalTraining = rootGetters['youngSecondPart/totalTraining'];
		return checkDisclaimer(userInfo, state, totalTraining, check);
	},
	totalTraining(state, getters, rootState, rootGetters) {
		let userInfo = rootGetters.userInfo;
		return userInfo && userInfo.people &&
		userInfo.people.people_advisor_training_with_trashed_count ? userInfo.people.people_advisor_training_with_trashed_count : 0;
	},
	showSearchCompany(state, getters, rootState, rootGetters) {
		let check = false;

		let userInfo = rootGetters.userInfo;
		let loadedProfile = rootGetters['young/loadedProfile'];
		let isCompleted = rootGetters['young/isCompleted'];
		let form = rootGetters['young/form'];

		let checkLetter = rootGetters['youngSecondPart/checkLetter'];
		let totalTraining = rootGetters['youngSecondPart/totalTraining'];

		if (userInfo.people.cat_people_status_id != 5 && userInfo.people.cat_people_status_id != 4) {

			if (loadedProfile &&
				isCompleted &&
				(!state.peopleAdvisorTraining ||
					(
						state.peopleAdvisorTraining &&
						state.peopleAdvisorTraining.last_log &&
						(
							state.peopleAdvisorTraining.last_log.status_id == 3 ||
							state.peopleAdvisorTraining.last_log.status_id == 5
						))
				) &&
				form &&
				checkLetter == false &&
				state.loaded === true &&
				userInfo &&
				userInfo.people && (totalTraining == 0 || totalTraining == 1)
			) {
				check = true;
			}
		}

		return check;
	},
	showTrainingCard(state, getters, rootState, rootGetters) {

		let check = false;
		let userInfo = rootGetters.userInfo;
		let loadedProfile = rootGetters['young/loadedProfile'];
		let isCompleted = rootGetters['young/isCompleted'];


		if (userInfo.people.cat_people_status_id != 5 && userInfo.people.cat_people_status_id != 4) {

			if (loadedProfile && isCompleted && state.peopleAdvisorTraining
				&& state.peopleAdvisorTraining.last_log && state.peopleAdvisorTraining.last_log.status_id == 2 &&
				state.loaded === true) {
				check = true;
			}
		}
		return check;
	},
	showPanelOfLinking(state, getters, rootState, rootGetters) {
		let check = false;
		let userInfo = rootGetters.userInfo;
		let totalTraining = rootGetters['youngSecondPart/totalTraining'];
		let loadedProfile = rootGetters['young/loadedProfile'];
		let isCompleted = rootGetters['young/isCompleted'];



		if (userInfo.people.cat_people_status_id != 5 && userInfo.people.cat_people_status_id != 4) {

			if (loadedProfile &&
				isCompleted &&
				(
					(state.peopleAdvisorTraining &&
						state.peopleAdvisorTraining.last_log &&
						state.peopleAdvisorTraining.last_log.status_id == 4) ||
					(
						totalTraining == 2 &&
						state.peopleAdvisorTraining &&
						state.peopleAdvisorTraining.last_log &&
						state.peopleAdvisorTraining.last_log.status_id  == 5
					)
				)
				&& state.loaded === true) {
				check = true;
			}
		}




		return check;
	},

};

// Mutations
const mutations = {
	changeOnlyRead(state, check) {
		state.onlyRead = !!check;
	},
	changeLoading(state, check) {
		state.loaded = check;
	},
	changePeopleAdvisorTraining(state, payload) {
		state.peopleAdvisorTraining = payload;

	},
};

// Actions
const actions = {
	serviceGetTraining({commit, dispatch}) {
		commit('changeLoading', false);

		dispatch('loading/spinner', {msg: 'Cargando información...', status: true}, {root: true});
		window.axios.get(`/api/people-advisor/get-training`)
			.then((response) => {

				dispatch('loading/spinner', {}, {root: true});
				const parsedResponse = response.data;
				if (parsedResponse && parsedResponse.success == true) {
					commit('changeLoading', true);
					commit('changePeopleAdvisorTraining', parsedResponse.data);
				}
			})
			.catch((err) => {

				dispatch('loading/spinner', {}, {root: true});
				let msg = 'No se pudo completar la acción';
				if (err.response &&
					err.response.data &&
					err.response.data.message
					&& err.response.status == 400) {
					msg = err.response.data.message;
				}
				dispatch('notifications/error', {msg: msg}, {root: true});

			});
	},


};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
